import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import * as daterangepicker from 'daterangepicker'; // Import DateRangePicker
import * as $ from 'jquery';
import * as moment from 'moment'; // Import moment

@Directive({
  selector: '[appDateTimepicker]',
})
export class DateTimepickerDirective implements AfterViewInit {
  @Input('format') format: any;
  @Input('start') start: any;
  @Input('end') end: any;
  @Output() change = new EventEmitter<any>();

  constructor(private el: ElementRef) {}
  ngAfterViewInit(): void {
    console.log(daterangepicker);
    let options = {
      singleDatePicker: true,
      timePicker: true,
      locale: {
        format: this.format,
      },
    } as any;

    const rex = /([+-]\d{2}:\d{2})$/;
    if (this.start && this.end) {
      options.startDate = moment(this.start.replace(rex, ''));
      options.endDate = moment(this.end.replace(rex, ''));
    }
    $(this.el.nativeElement).daterangepicker(options, (start, end, label) => {
      // Emit the start and end dates in the specified timezone

      const startDate = start.format('YYYY-MM-DD HH:mm:ss');
      const endDate = end.format('YYYY-MM-DD HH:mm:ss');
      this.change.emit({ start: startDate, end: endDate });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const startDate = changes['start'];
    if (
      startDate?.currentValue &&
      startDate?.currentValue !== startDate?.previousValue
    ) {
      try {
        let start = startDate?.currentValue;

        if (!(typeof startDate?.currentValue === 'string')) {
          start = start.toISOString();
        }

        const test = $(this.el.nativeElement).data('daterangepicker');
        test.setStartDate(new Date(start));
      } catch (e) {}
    }
  }
}
